import { Box, styled, Typography } from '@mui/material'

import appRead from '@ecm/effect/app/Read'
import KeepMailGreen from '@ecm/ui/component/block/KeepMailGreen'
import Articles from '@ecm/ui/component/green/Articles'
import EnvironmentalImpact from '@ecm/ui/component/green/EnvironmentalImpact'
import NFFBanner from '@ecm/ui/component/green/NFFBanner'
import Partners from '@ecm/ui/component/green/Partners'
import Steps from '@ecm/ui/component/green/Steps'
import Color from '@ecm/ui/element/Color'
import Feature from '@ecm/ui/element/Feature'
import DefaultLayout from '@ecm/ui/layout/Default'

import carbonCreditIllustration from '/public/images/illustration/carbon_credit_illustration.svg'
import greenHeroIllustration from '/public/images/illustration/green-hero-image.png'
import recycleIllustration from '/public/images/illustration/recycle_illustration.svg'
import reforestationIllustration from '/public/images/illustration/reforestation_illustration.svg'

type GreenProps = {
  className?: string
}

const sustainabilityGoals = [
  {
    icon: reforestationIllustration,
    label: (
      <>
        Supporting
        <br />
        <b>reforestation</b>
      </>
    ),
  },
  {
    icon: carbonCreditIllustration,
    label: (
      <>
        Purchasing
        <br />
        <b>carbon credits</b>
      </>
    ),
  },
  {
    icon: recycleIllustration,
    label: (
      <>
        Encouraging{' '}
        <b>
          recycling <br /> and repurposing
        </b>
      </>
    ),
  },
]

const GreenPage = styled(({ className }: GreenProps) => (
  <DefaultLayout
    metaImageUrl={`${appRead.ask().appUrl}/images/og-image-green-page.png`}
    metaTwitterCard="summary_large_image"
    seoPage="green"
    className={className}
    hideFinalCta
  >
    <Box
      sx={{
        background: `linear-gradient(180deg, ${Color.smoke.normal} 520px, rgba(255, 255, 255, 0) 750px)`,
      }}
    >
      <Feature
        asHero
        description={
          <>
            <Typography variant="p2">
              <b>Earth Class Mail, a LegalZoom company</b>, is committed to making and keeping mail
              green and helping our customers take steps towards a sustainable lifestyle for future
              generations.
            </Typography>
            <Typography variant="p2">
              <b>Join us in restoring and protecting our planet.</b>
            </Typography>
          </>
        }
        icon="ecm_earth_day_logo"
        illustrationSrc={greenHeroIllustration}
        imagePosition="right"
        title="Environmental Sustainability"
        illustrationWidth="100%"
        titleVariant="h2"
      />
      <EnvironmentalImpact />
    </Box>

    <NFFBanner />

    <KeepMailGreen
      heading="What we’re doing to keep mail green"
      subHeading="Our sustainability goals"
      steps={sustainabilityGoals}
    />

    <Partners />

    <Steps />

    <Articles />
  </DefaultLayout>
))({
  'h1, h2': {
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundImage: 'linear-gradient(272.81deg, #4EDF97 11.53%, #0F2272 100%)',
  },
})

export default GreenPage
